import clsx from "clsx";
import React, { useEffect } from "react";
import { Transition } from "react-transition-group";

import { useScrollLockContext } from "../../contexts/scrollLockContext";

import HorizontalRule from "../Rule/Horizontal";

export type CommonPopupProps = {
  isOpen?: boolean;
  onClose?: () => void;
  children?: React.ReactNode;
  title?: string | React.ReactNode; // 타입을 변경하여 JSX도 받을 수 있도록 수정
  padding?: number;
  unUseHorizonRule?: boolean;
};

export default function CommonPopup({
  onClose,
  children,
  title,
  unUseHorizonRule = false,
  padding = 6,
  isOpen = false,
}: CommonPopupProps) {
  const handleClose = () => {
    onClose?.();
  };

  const [, { lockScroll, unlockScroll }] = useScrollLockContext();

  const getPopupClassName = (state: string) => {
    switch (state) {
      case "entering":
        return "popup-entering";
      case "entered":
        return "popup-entered";
      case "exiting":
        return "popup-exiting";
      case "exited":
        return "popup-exited";
      default:
        return "";
    }
  };

  const getDimmedClassName = (state: string) => {
    switch (state) {
      case "entering":
        return "dimmed-entering";
      case "entered":
        return "dimmed-entered";
      case "exiting":
        return "dimmed-exiting";
      case "exited":
        return "dimmed-exited";
      default:
        return "";
    }
  };

  useEffect(() => {
    if (isOpen === true) {
      const scrollId = lockScroll?.({});

      return () => {
        unlockScroll?.({ activeElements: [scrollId] });
      };
    }
  }, [isOpen]);

  return (
    <Transition in={isOpen} timeout={300} unmountOnExit>
      {(state) => (
        <div
          className={clsx(["fixed inset-0 flex items-end justify-center z-50"])}
          data-testid="common-popup"
        >
          <div
            className={`fixed inset-0 bg-gray-800 cursor-pointer ${getDimmedClassName(
              state
            )}`}
            onClick={handleClose}
          />
          <div
            className={`w-full bg-white  z-10 rounded-t-xl transform transition-all duration-300 ${getPopupClassName(
              state
            )}`}
          >
            {title && (
              <div className="py-4">
                <h2
                  className="w-full flex justify-center text-xl font-semibold py-2.5 relative leading-[24px]"
                  style={{ whiteSpace: "pre-line" }} // 줄바꿈을 위해 추가
                >
                  {title}
                  {onClose && (
                    <div
                      className="absolute right-5 top-1/2 -translate-y-1/2"
                      onClick={() => onClose?.()}
                    >
                      <PopupCloseIcon />
                    </div>
                  )}
                </h2>
                {!unUseHorizonRule && <HorizontalRule />}
              </div>
            )}
            <div
              style={{ padding: `${padding * 0.25}rem`, paddingTop: 0 }}
              className="max-h-[75vh] overflow-y-scroll"
            >
              {children}
            </div>
          </div>
        </div>
      )}
    </Transition>
  );
}

export const PopupCloseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.3">
      <path
        d="M18 6L6 18"
        stroke="black"
        strokeWidth="1.75"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="black"
        strokeWidth="1.75"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
